import { render, staticRenderFns } from "./BuyInfo.vue?vue&type=template&id=1bd5bb8c&scoped=true&lang=html"
import script from "./BuyInfo.vue?vue&type=script&lang=js"
export * from "./BuyInfo.vue?vue&type=script&lang=js"
import style0 from "./BuyInfo.vue?vue&type=style&index=0&id=1bd5bb8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5bb8c",
  null
  
)

export default component.exports